export default {
  install(Vue)  {

    Vue.prototype.setLocalStorage = function(key, value) {
      var curtime = new Date().getTime(); // 获取当前时间 ，转换成JSON字符串序列
      var valueDate = JSON.stringify({
        val: value,
        timer: curtime
      });
      localStorage.setItem(key, valueDate);
    },
    
    Vue.prototype.getLocalStorage = function(key) {
      var exp = 60 * 60 * 24 * 1000 * 30; // 一天的秒数
      if (localStorage.getItem(key)) {
        var vals = localStorage.getItem(key); // 获取本地存储的值
        var dataObj = JSON.parse(vals); // 将字符串转换成JSON对象
        // 如果(当前时间 - 存储的元素在创建时候设置的时间) > 过期时间
        var isTimed = new Date().getTime() - dataObj.timer > exp;
        if (isTimed) {
          console.log("存储已过期");
          localStorage.removeItem(key);
          return null;
        } else {
          var newValue = dataObj.val;
        }
        return newValue;
      } else {
        return null;
      }
    },

    Vue.prototype.setDateArray = function(startdate,enddate) {
      var arrdate = [];
      var currentDate = this.$moment(startdate);
      var stopDate = this.$moment(enddate);
      while (currentDate <= stopDate) {
        arrdate.push( this.$moment(currentDate).format('YYYY-MM-DD') )
        currentDate = this.$moment(currentDate).add(1, 'days')
      }
      return arrdate
    },
    
    /**
    * 设置渠道ICON Logo
    */
    Vue.prototype.setChannel = function(cname){
      let src = ''
      let loc = ''
      let color = ''
      let name = ''
      let cid = ''
      if(isNaN(cname) === false){
        cname = cname*1
      }
      if(isNaN(cname/1) === false){
        cname = cname/1
      }
      switch (cname) {
        case "淘宝": case 1: case "Taobao":
          src = "logo-taobao";
          loc = this.$t("channels.c1");
          color = '#F6924F';
          name = '淘宝';
          cid = 1;
          break;
        case "天猫": case 2: case "Tmall":
          src = "logo-tmall";
          loc = this.$t("channels.c2");
          color = '#F47373';
          name = '天猫';
          cid = 2;
          break;
        case "京东": case 3: case "JD":
          src = "logo-jd";
          loc = this.$t("channels.c3");
          color = '#7290F2';
          name = '京东';
          cid = 3;
          break;
        case "苏宁": case 4: case "Suning":
          src = "logo-suning";
          loc = this.$t("channels.c4");
          color = '#ff8000';
          name = '苏宁';
          cid = 4;
          break;
        case "一号店": case 7: case "Yihaodian":
          src = "logo-yhd";
          loc = this.$t("channels.c7");
          color = '#f1503b';
          name = '一号店';
          cid = 7;
          break;
        case "寺库": case 9: case "Siku":
          src = "logo-siku";
          loc = this.$t("channels.c9")
          color = '#ffb81c';
          name = '寺库';
          cid = 9;
          break;
        case "唯品会": case 10: case "VIP":
          src = "logo-vipcom";
          loc = this.$t("channels.c10");
          color = '#f10180';
          name = '唯品会';
          cid = 10;
          break;
        case "尚品": case 11: case "Shangpin":
          src = "logo-shangpin";
          loc = this.$t("channels.c11");
          color = '';
          name = '尚品';
          cid = 11;
          break;
        case "洋码头": case 12: case "Ymatou":
          src = "logo-yangmatou";
          loc = this.$t("channels.c12");
          color = '#cc3333';
          name = '洋码头';
          cid = 12;
          break;
        case "国美": case 13: case "Gome":
          src = "logo-gome";
          loc = this.$t("channels.c13");
          color = '#b20fd3';
          name = '国美';
          cid = 13;
          break;
        case "亚马逊": case 14: case "亚马逊(日本)": case "Amazon(JP)":
          src = "logo-amazon";
          loc = this.$t("channels.c14");
          color = '#e47911';
          name = '亚马逊(日本)';
          cid = 14;
          break;
        case "当当": case 15: case "Dangdang":
          src = "logo-dangdang";
          loc = this.$t("channels.c15");
          color = '#ff2832';
          name = '当当';
          cid = 15;
          break;
        case "小红书": case 16: case "Xiaohongshu":
          src = "logo-xiaohongshu";
          loc = this.$t("channels.c16");
          color = '#ff2442';
          name = '小红书';
          cid = 16;
          break;
        case "考拉": case 17: case "Kaola":
          src = "logo-kaola";
          loc = this.$t("channels.c17");
          color = '#ff1e32';
          name = '考拉';
          cid = 17;
          break;
        case "美丽说": case 18: case "Meilishuo":
          src = "logo-meilishuo";
          loc = this.$t("channels.c18");
          color = '#fc4955';
          name = '美丽说';
          cid = 18;
          break;
        case "堆糖": case 19: case "Duitang":
          src = "logo-duitang";
          loc = this.$t("channels.c19");
          color = '#ff7e7e';
          name = '堆糖';
          cid = 19;
          break;
        case "小米商城": case 21: case "Mi":
          src = "logo-xiaomi";
          loc = this.$t("channels.c21");
          color = '#ff660';
          name = '小米商城';
          cid = 21;
          break;
        case "美妆心得": case 22: case "Meizhuangxinde":
          src = "logo-meizhuangxinde";
          loc = this.$t("channels.c22");
          color = '#ff4a83';
          name = '美妆心得';
          cid = 22;
          break;
        case "途虎": case 24: case "Tuhu":
          src = "logo-tuhu";
          loc = this.$t("channels.c24");
          color = '#d12a3e';
          name = '途虎';
          cid = 24;
          break;
        case "闲鱼": case 25: case "Xianyu":
          src = "logo-xianyu";
          loc = this.$t("channels.c25");
          color = '#fed802';
          name = '闲鱼';
          cid = 25;
          break;
        case "也买酒": case 26: case "Yesmywine":
          src = "logo-yesmywine";
          loc = this.$t("channels.c26");
          color = '#D3161B';
          name = '也买酒';
          cid = 26;
          break;
        case "云集": case 27: case "Yunji":
          src = "logo-yunji";
          loc = this.$t("channels.c27");
          color = '#dd0031';
          name = '云集';
          cid = 27;
          break;
        case "shopee": case 28: case "Shopee":
          src = "logo-shopee";
          loc = this.$t("channels.c28");
          color = '#ee4d2d';
          name = 'shopee';
          cid = 28;
          break;
        case "wish": case 29: case "Wish":
          src = "logo-wish";
          loc = this.$t("channels.c29");
          color = '#2fb7ec';
          name = 'wish';
          cid = 29;
          break;
        case "拼多多": case 30: case "PDD":
          src = "logo-pdd";
          loc = this.$t("channels.c30");
          color = '#F4C36F';
          name = '拼多多';
          cid = 30;
          break;
        case "1688": case 31: case 1688:
          src = "logo-1688";
          loc = this.$t("channels.c31");
          color = '#87CEFA';
          name = '1688';
          cid = 31;
          break;
        case "微店": case 32: case "Weidian":
          src = "logo-weidian";
          loc = this.$t("channels.c32");
          color = '#FFB6C1';
          name = '微店';
          cid = 32;
          break;
        case "yahoo": case 35: case "Yahoo": case "雅虎":
          src = "logo-yahoo";
          loc = this.$t("channels.c35");
          color = '#6001d2';
          name = 'yahoo';
          cid = 35;
          break;
        case "露天拍卖": case 36: case "Ruten":
          src = "logo-ruten";
          loc = this.$t("channels.c36");
          color = '#ef7b2e';
          name = '露天拍卖';
          cid = 36;
          break;
        case "carousell": case 38:
          src = "logo-carousell";
          loc = this.$t("channels.c38");
          color = '';
          name = 'carousell';
          cid = 38;
          break;
        case "hktvmall": case 39:
          src = "logo-hktvmall";
          loc = this.$t("channels.c39");
          color = '';
          name = 'hktvmall';
          cid = 39;
          break;
        case "COACH蔻驰官网": case 40: case "COACH":
          src = "logo-coach";
          loc = this.$t("channels.c40");
          color = '#020003';
          name = 'COACH蔻驰官网';
          cid = 40;
          break;
        case "COACH蔻驰奥莱官方网站": case 41: case "COACH Outlet":
          src = "logo-coach";
          loc = this.$t("channels.c41");
          color = '#6a6a6a';
          name = 'COACH蔻驰奥莱官方网站';
          cid = 41;
          break;  
        case "ebay": case 42:
          src = "logo-ebay";
          loc = this.$t("channels.c42");
          color = '';
          name = 'ebay';
          cid = 42;
          break;
        case "sshoeskid": case 43:
          src = "logo-sshoeskid";
          loc = this.$t("channels.c43");
          color = '';
          name = 'sshoeskid';
          cid = 43;
          break;
        case "ddsneakers": case 44:
          src = "logo-ddsneakers";
          loc = this.$t("channels.c44");
          color = '';
          name = 'ddsneakers';
          cid = 44;
          break;
        case "抖音电商": case 45: case "Douyin":
          src = "logo-douyin";
          loc = this.$t("channels.c45");
          color = '#00f8f0';
          name = '抖音电商';
          cid = 45;
          break;
        case "速卖通(日本)": case 46: case "AliExpress(JP)":
          src = "logo-aliexpress";
          loc = this.$t("channels.c46");
          color = '';
          name = '速卖通(日本)';
          cid = 46;
          break;
        case "阿里国际": case 47: case "Alibaba":
          src = "logo-alibaba";
          loc = this.$t("channels.c47");
          color = '';
          name = '阿里国际';
          cid = 47;
          break;
        case "sakurastation": case 48:
          src = "logo-sakurastation";
          loc = 'sakurastation';
          color = '';
          name = 'sakurastation';
          cid = 48;
          break;
        case "seeusoon": case 49:
          src = "logo-seeusoon";
          loc = 'seeusoon';
          color = '';
          name = 'seeusoon';
          cid = 49;
          break;
        case "KsBeauty": case 50:
          src = "logo-KsBeauty";
          loc = 'KsBeauty';
          color = '';
          name = 'KsBeauty';
          cid = 50;
          break;
        case "thiswayhk": case 51:
          src = "logo-thiswayhk";
          loc = 'thiswayhk';
          color = '';
          name = 'thiswayhk';
          cid = 51;
          break;
        case "百度健康": case 52:
          src = "logo-baidujiankang";
          loc = '百度健康';
          color = '#19bdb2';
          name = '百度健康';
          cid = 52;
          break;
        case "1药网": case 53:
          src = "logo-1yaowang";
          loc = '1药网';
          color = '#FF0000';
          name = '1药网';
          cid = 53;
          break;
        case "平安健康": case 54:
          src = "logo-pinganjiankang";
          loc = '平安健康';
          color = '#f05a23';
          name = '平安健康';
          cid = 54;
          break;
        case "药房网": case 55:
          src = "logo-yaofangwang";
          loc = '药房网';
          color = '#0cb95f';
          name = '药房网';
          cid = 55;
          break;
        case "得物": case 56:
          src = "logo-dewu";
          loc = '得物';
          color = '#01c2c3';
          name = '得物';
          cid = 56;
          break;
        case "Shopee (ID)": case 57:
          src = "logo-shopee";
          loc = 'Shopee (ID)';
          color = '#ee4d2d';
          name = 'Shopee (ID)';
          cid = 57;
          break;
        case "Lazada (ID)": case 58:
          src = "logo-lazada";
          loc = 'Lazada (ID)';
          color = '#003992';
          name = 'Lazada (ID)';
          cid = 58;
          break;
        case "Tokopedia (ID)": case 59:
          src = "logo-tokopedia";
          loc = 'Tokopedia (ID)';
          color = '#61ba53';
          name = 'Tokopedia (ID)';
          cid = 59;
          break;
        case "TikTok (ID)": case 60:
          src = "logo-douyin";
          loc = 'TikTok (ID)';
          color = '#00f8f0';
          name = 'TikTok (ID)';
          cid = 60;
          break;
        case "Shopee (SG)": case 63:
          src = "logo-shopee";
          loc = 'Shopee (SG)';
          color = '#ee4d2d';
          name = 'Shopee (SG)';
          cid = 63;
          break;
        case "Shopee (PH)": case 64:
          src = "logo-shopee";
          loc = 'Shopee (PH)';
          color = '#114d2d';
          name = 'Shopee (PH)';
          cid = 64;
          break;
        case "Lazada (SG)": case 61:
          src = "logo-lazada";
          loc = 'Lazada (SG)';
          color = '#DD4d2d';
          name = 'Lazada (SG)';
          cid = 61;
          break;
        case "shopback (SG)": case 62:
          src = "logo-shopback";
          loc = 'shopback (SG)';
          color = '#FF4d2d';
          name = 'shopback (SG)';
          cid = 62;
          break;
        case "美团": case 65:
          src = "logo-meituan";
          loc = '美团';
          color = '#FDC22C';
          name = '美团';
          cid = 65;
          break;
        case "盒马": case 67:
          src = "logo-hema";
          loc = '盒马';
          color = '#53b8ff';
          name = '盒马';
          cid = 67;
          break;
        case "Lazada (MY)": case 68:
          src = "logo-lazada";
          loc = 'Lazada (MY)';
          color = '';
          name = 'Lazada (MY)';
          cid = 68;
          break;
        case "Shopee (MY)": case 69:
          src = "logo-shopee";
          loc = 'Shopee (MY)';
          color = '';
          name = 'Shopee (MY)';
          cid = 69;
          break;
        case "Lazada (TH)": case 70:
          src = "logo-lazada";
          loc = 'Lazada (TH)';
          color = '';
          name = 'Lazada (TH)';
          cid = 70;
          break;
        case "Shopee (TH)": case 71:
          src = "logo-shopee";
          loc = 'Shopee (TH)';
          color = '';
          name = 'Shopee (TH)';
          cid = 71;
          break;
        case "Gmarket": case 72:
          src = "logo-gmarket";
          loc = 'Gmarket (KR)';
          color = '#00c01e';
          name = 'Gmarket';
          cid = 72;
          break;
        case "Coupang": case 73:
          src = "logo-coupang";
          loc = 'Coupang (KR)';
          color = '#af1605';
          name = 'Coupang';
          cid = 73;
          break;
        case "Naver": case 74:
          src = "logo-naver";
          loc = 'Naver (KR)';
          color = '#03d760';
          name = 'Naver';
          cid = 74;
          break;
        case "Yahoo(JP)": case 75:
          src = "logo-yahoo";
          loc = 'Yahoo Auction (JP)';
          color = '';
          name = 'Yahoo(JP)';
          cid = 75;
          break;
        case "fril": case 76:
          src = "logo-fril";
          loc = 'Rakuma (JP)';
          color = '#002896';
          name = 'fril';
          cid = 76;
          break;
        case "药师帮": case 78:
          src = "logo-yaoshibang";
          loc = '药师帮';
          color = '';
          name = '药师帮';
          cid = 78;
          break;
        case "1药城": case 79:
          src = "logo-1yaocheng";
          loc = '1药城';
          color = '';
          name = '1药城';
          cid = 79;
          break;
        case "iopenmall": case 80:
          src = "logo-iopenmall";
          loc = 'iopenmall';
          color = '';
          name = 'iopenmall';
          cid = 80;
          break;
        case "酒仙网": case 81:
          src = "logo-jiuxian";
          loc = '酒仙网';
          color = '';
          name = '酒仙网';
          cid = 81;
          break;
        case "真酒网": case 82:
          src = "logo-zhenjiu";
          loc = '真酒网';
          color = '';
          name = '真酒网';
          cid = 82;
          break;
        default:
          src = "";
          loc = ""
          break;
      }
      let obj = {
        src: src,
        loc: loc,
        color: color,
        name: name,
        cid: cid
      }
      return obj
    }

    Vue.prototype.millonFormat = function (n, money) {
      let minus = n < 0 ? true : false
      n = n < 0 ? Math.abs(n) : n
      n = money ? n.toFixed(2).toString() : n.toString();
      var re = /\d{1,3}(?=(\d{3})+$)/g;
      var n1 = n.replace(/^(\d+)((\.\d+)?)$/, function (s, s1, s2) { return s1.replace(re, "$&,") + s2; });
      n1 = minus ? '-' + n1 : n1;
      return n1;
    },

    Vue.prototype.checkfakeicons = function (item, items) {
      let showicon = false
      if(items.indexOf(item) != -1){
        showicon = true
      }
      return showicon
    },

    Vue.prototype.getTableCellStyle = function ({ column }) {
      const tempWidth = column.realWidth || column.width
      if (column.showOverflowTooltip) {
        return {
          minWidth: tempWidth + 'px',
          maxWidth: tempWidth + 'px'
        }
      }
      return {}
    },

    Vue.prototype.setFakeproductType = function(t) {
      let txt = "";
      switch (t) {
        case "imgCheck":
          txt = this.$t("aistring.s1");
          break;
        case "Lowprice":
          txt = this.$t("aistring.s10");
          break;
        case "HighSales":
          txt = this.$t("aistring.s11");
          break;
        case "KeyWords":
          txt = this.$t("aistring.s12");
          break;
        case "Daigou":
          txt = this.$t("aistring.s13");
          break;
        default:
          txt = "";
          break;
      }
      return txt
    },

    Vue.prototype.setInfringementsType = function(t) {
      let txt = "";
      let color = "";
      switch (t) {
        case "daotu": case "盗图":
          txt = this.$t("aistring.s1");
          color = "#EE3B3B";
          break;
        case "mxjiam": case "明显假冒":
          txt = this.$t("aistring.s2");
          color = "#FF3E96";
          break;
        case "Ppdaoy": case "品牌盗用":
          txt = this.$t("aistring.s3");
          color = "#faa755";
          break;
        case "ysjiam": case "疑似假冒":
          txt = this.$t("aistring.s4");
          color = "#f47920";
          break;
        case "wuyic": case "无异常商品":
          txt = this.$t("aistring.s5");
          color = "#7290F2";
          break;
        default:
          txt = "";
          color = "";
          break;
      }
      let obj = {
        txt: txt,
        color: color
      }
      return obj
    },

    Vue.prototype.setInfringementsSuggestion = function(t) {
      let txt = "";
      let color = "";
      switch (t) {
        case "wuxucz": case "无需操作":
          txt = this.$t("aistring.s6");
          color = "#7290F2";
          break;
        case "daireng": case "待人工判定":
          txt = this.$t("aistring.s7");
          color = "#E5585E";
          break;
        case "xianshangt": case "线上投诉":
          txt = this.$t("aistring.s8");
          color = "#ef4136";
          break;
        case "miqiegz": case "密切关注":
          txt = this.$t("aistring.s9");
          color = "#f47920";
          break;
        case "wuyic": case "无异常商品":
          txt = this.$t("aistring.s5");
          color = "#426ab3";
          break;
        default:
          txt = "";
          color = "";
          break;
      }
      let obj = {
        txt: txt,
        color: color
      }
      return obj
    },
    
    /**
     * 代购卖家统计占比
     */
    Vue.prototype.setDaigouSellersCount = function(item){
      let s = ''
      switch(item){
        case '一般':
          s = this.$t('Seller.t7');
          break;
        case '跨境':
          s = this.$t('Seller.t8');
          break;
        case '代购':
          s = this.$t('Seller.t9');
          break;
        default:
          s = '';
          break;
      }
      return s
    }

    /**
     * 格式化处理优先级
     */
    Vue.prototype.setLevels = function(item){
      let s = ''
      if(item!=null){
        let n = item/1
        if(n === 0) {
          s = this.$t('jgjk.s268')
        }
        if(n > 0 && n <= 0.2) {
          s = this.$t('jgjk.s269')
        }
        if(n > 0.2) {
          s = this.$t('jgjk.s270')
        }
      }else{
        s = this.$t('jgjk.s268')
      }
      return s
    }

    /**
     * 格式化销售额
     */
    Vue.prototype.formartAmount= function(am){
      let _am = ''
      if(am===null || am==='' || am===undefined){
        am = 0
      }
      if(am<1000){
        _am = '<1k'
      }
      if(am >= 1000 && am < 10000){
        _am = Math.round(am/1000) + 'k'
      }
      if(am >= 10000){
        _am = Math.round(am/10000) + 'w'
      }
      return _am
    }

    /**
     * 价格处理优先级
     */
    Vue.prototype.setPriorityLevel= function(amount, channelid){
      let str = ''
      if(channelid === 0){
        if(amount < 10000){
          str = this.$t('jgjk.s268')
        }
        if(amount >= 10000 && amount < 100000){
          str = this.$t('jgjk.s269')
        }
        if(amount >= 100000){
          str = this.$t('jgjk.s270')
        }
      }
      if(channelid === 1){
        if(amount < 1000){
          str = this.$t('jgjk.s268')
        }
        if(amount >= 1000 && amount < 50000){
          str = this.$t('jgjk.s269')
        }
        if(amount >= 50000){
          str = this.$t('jgjk.s270')
        }
      }
      return str
    }

    /**
     * 格式化涨跌
     */
    Vue.prototype.setCompare= function(current, rate){
      let _rate = rate >=0 ? '+' + (rate * 100).toFixed(2) + '%' : (rate * 100).toFixed(2) + '%'
      let h2 = rate >=0 ? current + '<span class="report-numcarts-color-red"><i class="el-icon-sell"></i> ' + _rate + '</span>' :
                          current + '<span class="report-numcarts-color-green"><i class="el-icon-sold-out"></i> ' + _rate + '</span>'
      return h2
    }

    /**
     * 格式化比例
     */
    Vue.prototype.setPercentage= function(p, rate){
      let _rate = rate >=0 ? '+' + (rate * 100).toFixed(2) + '%' : (rate * 100).toFixed(2) + '%'
      let html = rate >=0 ? (p * 100).toFixed(2) + '%' + '<span class="report-numcarts-color-red"><i class="el-icon-sell"></i> ' + _rate + '</span>' :
          (p * 100).toFixed(2) + '%' + '<span class="report-numcarts-color-green"><i class="el-icon-sold-out"></i> ' + _rate + '</span>'
      return html
    }

    /**
     * 标准化报告数据表格
     */
    Vue.prototype.setReportTable= function(obj){
      let that = this
      obj.forEach(item => {
        item.Channel = that.setChannel(item.Channel).src
        item.Discount = (item.Discount).toFixed(2) + "%"
        item.OFF = item.OFF != undefined && item.OFF != '' && item.OFF != null ? (item.OFF).toFixed(2) + "%" : ''
        item.IsAuthor = item.IsAuthor/1 === 1 ? that.$t('dsfx.t52') : that.$t('dsfx.t53')
        item.SkuTotalAmountStr = item.Channel == '拼多多' || item.Channel == '微店' ? that.$t('jgjk.s245') + that.formartAmount(item.SkuTotalAmount) : 
                      item.Channel == '京东' ? 'NA' : that.$t('jgjk.s246') + that.formartAmount(item.SkuTotalAmount)
      })
      return obj
    },

    /**
     * 获取当前订阅信息
     */
    Vue.prototype.getCurrentInfo = function(){
      let that = this
      let priceArr = JSON.parse(localStorage.getItem("price")).val
      let current = {}
      for(let i=0; i<priceArr.length; i++){
        if(priceArr[i].subid/1 === that.$route.params.Id/1){
          current = priceArr[i]
        }
      }
      return current
    },

    /**
     * 判断是否一天内
     */
    Vue.prototype.checkCrawltime = function(ctime, ntime){
      if(ctime){
        if(this.$moment(ntime).diff(this.$moment(ctime),'hours') < 24){
          return true
        }else{
          return false
        }
      }else{
        return false
      }
    },
    
    /**
     * 判定价格变化时间
     */
     Vue.prototype.checkPricediff = function(t, p){
      let r = 0
      let that = this
      if(t!=''&&t!=null&&t!=undefined){
        if(p>0){
          if(that.$moment(new Date()).diff(t, 'hours') <= 24){
            r = 1
          }
          if(that.$moment(new Date()).diff(t, 'hours') > 24 && 
            that.$moment(new Date()).diff(t, 'hours') <= 48){
            r = 3
          }
        }
        if(p<0){
          if(that.$moment(new Date()).diff(t, 'hours') <= 24){
            r = 2
          }
          if(that.$moment(new Date()).diff(t, 'hours') > 24 && 
            that.$moment(new Date()).diff(t, 'hours') <= 48){
            r = 4
          }
        }
      }
      return r
    },

    /**
     * 数据列表字段格式化
     */
    Vue.prototype.formatTablefields = function(data){
      let that = this
      // let getNow = that.$moment(new Date()).utc(8)
      data.forEach(item => {
        item.AssetIdIcon = item.HasNew == 1 ? item.AssetId + ' <i class="icon-newdata-txt">New</i>' : item.AssetId
        item.jiamao = that.checkfakeicons('明显假冒', item.itemlab)
        item.shangbiao = that.checkfakeicons('滥用商标词', item.itemlab)
        item.daotu = that.checkfakeicons('盗图', item.itemlab)
        item.ChannelIcon = that.setChannel(item.Channel).src
        item.authorize = item.IsAuthor/1 === 0 ? that.$t('dsfx.t53') : that.$t('dsfx.t52')
        item.MarginPercent = (item.MarginPercent * 100).toFixed(2) + "%"
        item.SkuMap = item.SkuMap ? item.SkuMap : item.skuMap
        // item.SkuTotalAmountStr = item.Channel == '拼多多' || item.Channel == '微店' ? that.$t('jgjk.s245') + that.formartAmount(item.SkuTotalAmount) : 
                                  // item.Channel == '京东' ? 'NA' : that.$t('jgjk.s246') + that.formartAmount(item.SkuTotalAmount)
        item.SkuTotalAmountStr = (item.SkuTotalAmount * 1) >=0 && item.SkuTotalAmount != null ? that.millonFormat((item.SkuTotalAmount * 1).toFixed(0)) : item.SkuTotalAmount
        item.StockNumStr = item.StockNum == 0 ? that.$t('dsfx.t52') : that.$t('dsfx.t53')
        item.StockNumDisplay = item.StockNum == null ? 'NA' : item.StockNum
        item.pricediff = that.checkPricediff(item.pricedate, item.discrepancy)
        item.SkuTotalTrade = item.SkuTotalTrade >=0 && item.SkuTotalTrade != null ? (item.SkuTotalTrade*1).toFixed(0) : item.SkuTotalTrade
        item.istousu = false
        item.iseditnotes = false
        item.notes = item.notes == null || item.notes == 'null' || item.notes == '' ? '' : item.notes,
        item.activitylevel = that.setActivityLevel(item.monitortotal)
      })
      return data
    },
    
    Vue.prototype.setActivityLevel = function(l){
      let r = {
        txt: '',
        classname: ''
      }
      if (l == 0) {
        r = {
          txt: '不活跃',
          classname: ''          
        }
      } else if (l >= 1 && l <= 2) {
        r = {
          txt: '活跃',
          classname: 'status-yellow'          
        }
      } else if (l >= 3 && l <= 8) {
        r = {
          txt: '高活跃',
          classname: 'status-red'          
        }
      } else {
        r = ""
      }
      return r
    }

  }
}